import React, { useEffect, useLayoutEffect } from "react";
// Components
import {
  Filters,
  Header,
  Tabs,
  Table,
  Pagination,
} from "Components/JoinRequests";
// Hooks
import { JoinRequestTable } from "hooks/useTable";
// Store Utils
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { TableProps } from "Components/Species/Table/types";
import { setJoinRequestFiltersAction } from "store/filters/reducer.actions";
import { filtersInitialState } from "store/filters/initialState";
import { useParams } from "react-router-dom";
import NoRecordFound from "view/components/NoRecordFound";
import { TailSpin } from "react-loader-spinner";
import { saveFiltersDataToLocalStorage } from "utils/cacheOrRetriveFiltersDate";
import { fetchJoinRequestMembersAction } from "store/joinRequests/reducer.actions";
import { IfetchJoinRequest } from "store/joinRequests/initialState";
import useCustomBranding from "hooks/useCustomBranding";

export const JoinRequests = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { programId } = useParams();
  const { data } = useSelector<RootState, IfetchJoinRequest>(
    (state) => state?.joinRequestMembers
  );

  useLayoutEffect(() => {
    dispatch(setJoinRequestFiltersAction());
  }, []);

  const { joinRequestFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  const {
    flexRender,
    columnVisibility,
    columnOrder,
    columnsConfig,
    table,
    setColumnsConfig,
    setColumnOrder,
    setColumnVisibility,
    setSorting,
    sorting,
  } = JoinRequestTable(data?.requests);

  useEffect(() => {
    if (programId) {
      dispatch(fetchJoinRequestMembersAction(programId));
    }
    saveFiltersDataToLocalStorage(joinRequestFilter);
  }, [joinRequestFilter]);

  return (
    <div className="flex flex-col items-start justify-start w-full pt-4 pb-20">
      <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full gap-3">
        <Header />
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full gap-4">
          <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
              <div className="flex justify-start  flex-wrap items-center self-stretch flex-grow-0 flex-shrink-0 min-h-[60px]">
                <Tabs />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
              <Filters
                columnOrder={columnOrder}
                setColumnOrder={setColumnOrder}
                columns={columnsConfig}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                setColumnsConfig={setColumnsConfig}
              />
            </div>
          </div>
        </div>
        <RednderView
          flexRender={flexRender}
          table={table}
          columnOrder={columnOrder}
          columns={columnsConfig}
          columnVisibility={columnVisibility}
          setSorting={setSorting}
          sorting={sorting}
        />
      </div>
    </div>
  );
};
export default JoinRequests;

const RednderView: React.FC<TableProps> = ({
  flexRender,
  table,
  columnVisibility,
  setSorting,
  sorting,
}) => {
  const { data, stateIs } = useSelector<RootState, IfetchJoinRequest>(
    (state) => state?.joinRequestMembers
  );
  const { primaryColor} = useCustomBranding();
  return (
    <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full dark:bg-secondaryLight bg-bgWhite">
      {stateIs == "Idle" && data?.requests?.length === 0 ? (
        <NoRecordFound />
      ) : stateIs === "Pending" ? (
        <div className="loader min-h-[45vh] justify-center items-center flex w-full">
          <TailSpin
            height="50"
            width="50"
            color={primaryColor}
            ariaLabel="tail-spin-loading"
            radius="2"
            wrapperStyle={{}}
            wrapperClass="tailspin-loader"
            visible={true}
          />
        </div>
      ) : (
        <Table
          flexRender={flexRender}
          table={table}
          columnVisibility={columnVisibility}
          setSorting={setSorting}
          sorting={sorting}
        />
      )}
      <Pagination />
    </div>
  );
};
